import { PostalOfficeType } from 'types';

const pairs = [
  ['MD', PostalOfficeType.POST_OFFICE],
  ['AP', PostalOfficeType.POST_AGENCY],
  ['CP', PostalOfficeType.POST_CENTER],
  ['PT', PostalOfficeType.POST_TERMINAL],
  ['CR', PostalOfficeType.FAST_COURIER_CENTER],
  ['CT', PostalOfficeType.TRANSIT_CENTER],
  ['DP', PostalOfficeType.DEPOSIT],
];
const reversedPairs = pairs.map((pair) => [...pair].reverse());

export const officeCodeToType: Record<string, PostalOfficeType> = Object.fromEntries(pairs);
export const officeTypeToCode: Record<PostalOfficeType, string> = Object.fromEntries(reversedPairs);
